import { Component, inject } from '@angular/core';
import { Item, ItemActionResult, ListViewProviderDirective } from '@ntap/core';
import { PrimeNGButtonNewItemViewActionComponent } from '@ntap/primeng';
import { map, tap, Observable } from 'rxjs';

@Component({
  selector: 'app-open-zahtjev-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class NewZahtjevActionComponent extends PrimeNGButtonNewItemViewActionComponent {
  protected listViewProvider = inject(ListViewProviderDirective);

  protected override doExecuteWithItem(
    item: Item
  ): Observable<ItemActionResult> {
    return super.doExecuteWithItem(item).pipe(
      tap(() => this.listViewProvider.refresh()),
      map(() => {
        return { result: {} } as ItemActionResult;
      })
    ); // na empty se neće ništa vraćati ni stavljati u parent listu
  }
}
